<template>
  <v-dialog class="modal" v-model="internal" max-width="500px">
    <v-card v-if="isOffset==='RiskSnapShot'">
      <v-card-title class="font-weight-medium text-body">
        {{ $t('offsetModal.enterHedgeSize') }} <br />
        {{ $t('offsetModal.suggestedToNeutralize', { size: suggestedSize.toFixed(1) }) }}</v-card-title
      >
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            block
            v-model="hedgeInput"
            :label="$t('offsetModal.enterHedgeSizeLabel')"
          ></v-text-field>
        </v-form>

        <v-btn
          block
          color="#ffbf00"
          class="mt-1 rounded-xl mx-auto black--text tracking-normal text-none"
          @click="handleSubmit"
          >{{ $t('instructions.submit') }}</v-btn
        >
      </v-card-text>
    </v-card>

    <v-card v-else-if="isOffset === 'OffsetLog'">
      <v-card-title class="justify-center pb-6">{{ $t('offsetModal.entryDetails') }}</v-card-title>
      <v-card-text class="d-flex align-center flex-column py-2">
      <p>{{ $t('offsetModal.time') }} {{ entry?.time }}</p>
       <p>{{ $t('offsetModal.action') }} {{ entry?.action }}</p>
       <p>{{ $t('offsetModal.hedgeSize') }} {{ entry?.hedgeSize }} </p>
        <p>{{ $t('offsetModal.dealPrice') }} {{ entry?.dealPrice }}</p>
        <p>{{ $t('offsetModal.offsetAvg') }} {{ entry?.offsetPrice }}</p>
        <p class="font-weight-bold":style="{ color: entry?.pnl.bps > 0 ? '#00ff88' : '#ff4444' }">
          {{ $t('offsetModal.realizedPnl') }} {{ entry?.pnl.label }}{{ entry?.pnl.pct }}% / {{ entry?.pnl.label
          }}{{ entry.pnl.bps }}bps
        </p>
      </v-card-text>
    </v-card>

        <v-card v-else-if="isOffset === 'MonteCarlo'">
      <v-card-title class="justify-center pb-6">{{ $t('offsetModal.monteCarloSuccess') }}</v-card-title>
      <v-card-text class="d-flex align-center flex-column py-2">
       <p>{{ entry?.action }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "MarketModal",
  data() {
    return {
      hedgeInput: "",
    };
  },
  emits: ["confirm-event"],
  props: {
    value: { type: Boolean, default: false },
    currentExposureUSD: { type: Number, required: false },
    isOffset: { value: String, required: true },
    entry: { type: Object, required: false },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.$emit("confirm-event", this.hedgeInput);
      this.internal = false;
    },
  },
  watch: {
    currentExposureUSD(newVal) {
      if (this.internal) {
        this.hedgeInput = Math.abs(newVal).toFixed(1);
      }
    },
    internal(val) {
      if (val) {
        this.hedgeInput = this.suggestedSize.toFixed(1);
      }
    },
  },
  computed: {
    suggestedSize() {
      return Math.abs(this.currentExposureUSD);
    },
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Albert+Sans:ital,wght@0,100..900;1,100..900&display=swap");

.v-dialog {
  font-family: "Albert Sans", sans-serif;
}
.v-dialog {
  border-radius: 15px;
}


.v-overlay--active {
  backdrop-filter: blur(6px) !important;
  background-color: rgba(0, 0, 0, 0.438) !important;
}
</style>
